document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.aa-faq');
  if (!section) return;

  const input = section.querySelector('[data-faq-search]');
  const clearButton = section.querySelector('[data-faq-clear]');
  const items = Array.from(section.querySelectorAll('[data-faq-item]'));
  const list = section.querySelector('[data-faq-list]');
  const empty = section.querySelector('[data-faq-empty]');
  if (!input) return;

  const filter = () => {
    const query = input.value.trim().toLowerCase();
    let visibleCount = 0;

    // Walk the list in page order so each category heading can follow its
    // group: it shows only if at least one question under it matches.
    let currentHeading = null;
    let headingHasMatch = false;
    const settleHeading = () => {
      if (currentHeading) currentHeading.hidden = query !== '' && !headingHasMatch;
    };

    Array.from(list ? list.children : items).forEach((el) => {
      if (el.hasAttribute('data-faq-heading')) {
        settleHeading();
        currentHeading = el;
        headingHasMatch = false;
        return;
      }
      if (!el.hasAttribute('data-faq-item')) return;
      const matches = query === '' || el.dataset.faqSearch.includes(query);
      el.hidden = !matches;
      if (matches) {
        visibleCount += 1;
        headingHasMatch = true;
      }
    });
    settleHeading();

    if (clearButton) clearButton.hidden = query === '';
    if (list) list.hidden = visibleCount === 0;
    if (empty) empty.hidden = visibleCount !== 0;
  };

  let debounce;
  input.addEventListener('input', () => {
    clearTimeout(debounce);
    debounce = setTimeout(filter, 150);
  });

  if (clearButton) {
    clearButton.addEventListener('click', () => {
      input.value = '';
      input.focus();
      filter();
    });
  }
});
